import React from "react";

const BlogIcon = () => {
  return (
    <div>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 6H8C6.9 6 6 6.9 6 8V24C6 25.1 6.9 26 8 26H24C25.1 26 26 25.1 26 24V12L20 6ZM8 24V8H19V13H24V24H8ZM10 14H22V16H10V14ZM10 18H22V20H10V18ZM10 10H16V12H10V10Z" />
      </svg>
    </div>
  );
};

export default BlogIcon;
